export class InfoMessageItem {
    id: number = -1;
    header: string = '';
    message: string = '';
    activateDate: Date = new Date();
    deactivateDate: Date = new Date()
    importance: number = -1;
}